'use client';
import Image from "next/image";

const SocialIcons = () => {
  return (
    <div className="social-icons">
      <a href="https://www.instagram.com/munich.indians" target="_blank" rel="noopener noreferrer">
        <Image src="/images/Footer/instagram.png" alt="Instagram" width={24} height={24} />
      </a>
      <a href="https://www.youtube.com/@munich.indians" target="_blank" rel="noopener noreferrer">
        <Image src="/images/Footer/youtube.png" alt="YouTube" width={24} height={24} />
      </a>
      <a href="https://www.linkedin.com/company/munichindians" target="_blank" rel="noopener noreferrer">
        <Image src="/images/Footer/linkedIn.png" alt="LinkedIn" width={24} height={24} />
      </a>
    </div>
  );
};

export default SocialIcons;
